module.exports = __webpack_public_path__ + "img/PG1-3-475x371.61f4569d.png";